<div class="callout" *ngIf="profile">
    <div class="upc_top"></div>
    <cm-user-profiles-list [profile]="profile" [profiles]="profiles"> </cm-user-profiles-list>
</div>
